import { IGoldRateTable } from "../types/type-city-scrollable-table.types";
import { API_PATHS } from "../constants/api-paths";
import { logErrorToNewRelic } from "../utils/logging";
import { request } from "../core/api.client";

export const getSelectedCityData = async (city: string): Promise<IGoldRateTable[]> => {
  try {
    const response = <{ data: IGoldRateTable[]; statusCode: number }>(
      await request({ method: "GET", url: `${API_PATHS.goldRateCity}?city=${city}` })
    );
    if (response.statusCode === 99) {
      return [];
    }
    return response.data;
  } catch (error) {
    logErrorToNewRelic(error as Error);
    return [];
  }
};

export const getAllCitiesData = async (totalCities?: number) => {
  const suffix = totalCities ? `?totalCities=${totalCities}` : "";
  const response = await request<IGoldRateTable[]>({
    method: "GET",
    url: `${API_PATHS.goldRateCities}${suffix}`,
  });

  return response;
};
